import { X, Lock, PenLine } from 'lucide-react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { useUserStore } from '@caradasstore/UserStore'
import { CaradasAvatar, PasswordForm, PhoneNumberForm } from '@components/user'
import { AdasBox, AdasButton, AdasCard, AdasDivider, AdasTypography } from '@components/wrapper-components'
import { phoneNumberFormat } from '../../../../utils/utils'

const userPrivilegeStatus = (user) => {
  if (user.is_admin) return 'Admin'
  if (user.is_owner) return 'Owner'
  if (user.is_manager) return 'Manager'
  return 'Tech'
}

export const UserProfile = ({ user, closeDrawer }) => {
  const [updatedUser, setUpdatedUser] = useState(user)
  const [isEditPassword, setIsEditPassword] = useState(false)
  const [isEditPhone, setIsEditPhone] = useState(false)
  const setCurrentUser = useUserStore((store) => store.setCurrentUser)

  const labelStyle = {
    margin: '.5rem 0 0 0',
    fontWeight: '600'
  }

  const onSaveUserSuccessHandler = (props) => {
    setUpdatedUser(props)
    setCurrentUser(props)
    setIsEditPassword(false)
  }

  return (
    <AdasBox>
      <AdasBox className='drawer-title-container'>
        <AdasTypography variant='h6' className='capitalize'>
          User Profile
        </AdasTypography>
        <AdasButton buttonType='iconButton' className='text-info cursor-pointer p-0.5' onClick={closeDrawer}>
          <X className='w-4 h-4' />
        </AdasButton>
      </AdasBox>
      <AdasCard className='adas-card'>
        <AdasBox className='flex items-center'>
          <CaradasAvatar user={user} />
          <AdasBox className='ml-4 mt-[-1rem]'>
            <AdasTypography className='font-semibold mt-4' variant='h6'>
              {updatedUser?.name}
            </AdasTypography>
            <AdasTypography variant='body2'>{userPrivilegeStatus(user)}</AdasTypography>
          </AdasBox>
        </AdasBox>
        <AdasTypography className='mt-2 font-semibold' variant='subtitle2'>
          Email
        </AdasTypography>
        <AdasTypography>{updatedUser?.email}</AdasTypography>
        {isEditPhone ? (
          <PhoneNumberForm
            user={updatedUser}
            open={isEditPhone}
            close={() => setIsEditPhone(false)}
            onSaveSuccess={onSaveUserSuccessHandler}
          />
        ) : (
          <AdasBox className='flex justify-between mt-4'>
            <AdasBox>
              <AdasTypography className='mt-2 font-semibold' variant='subtitle2'>
                Phone Number
              </AdasTypography>
              <AdasTypography>{phoneNumberFormat(updatedUser.phone)}</AdasTypography>
            </AdasBox>
            <AdasButton
              className='self-end'
              startIcon={<PenLine />}
              key='2'
              aria-label='Cancel'
              color='primary'
              onClick={() => setIsEditPhone(true)}
            >
              Edit
            </AdasButton>
          </AdasBox>
        )}
        <AdasDivider className='my-4 mx-0' />

        {isEditPassword ? (
          <PasswordForm user={updatedUser} close={() => setIsEditPassword(false)} onSaveSuccess={() => {}} />
        ) : (
          <AdasBox className='flex justify-between'>
            <AdasBox>
              <AdasTypography className='mt-2 font-semibold' variant='subtitle2'>
                Password
              </AdasTypography>
              <AdasTypography>**************</AdasTypography>
            </AdasBox>
            <AdasButton
              className='self-end'
              startIcon={<Lock /* mapped from MUI: LockResetIcon */ />}
              key='2'
              aria-label='Cancel'
              color='primary'
              onClick={() => setIsEditPassword(true)}
            >
              Reset
            </AdasButton>
          </AdasBox>
        )}
      </AdasCard>
    </AdasBox>
  )
}

UserProfile.propTypes = { user: PropTypes.object, closeDrawer: PropTypes.func.isRequired }
